module.exports = __webpack_public_path__ + "media/images/app/homepage/occasions/professional-54794659e43a71136f1d7ffc738bacb5.webp";